type Cleanup = () => void;
type IdleWindow = Window & typeof globalThis & {
  requestIdleCallback?: (callback: IdleRequestCallback, options?: IdleRequestOptions) => number;
  cancelIdleCallback?: (handle: number) => void;
};

/** Non-critical interaction polish loads only after the critical rendering path is quiet. */
export function setupIdleEnhancements(reduced: MediaQueryList, finePointer: MediaQueryList): Cleanup {
  const idleWindow = window as IdleWindow;
  let cancelled = false;
  let idleHandle = 0;
  let timeoutHandle = 0;
  let cleanups: Cleanup[] = [];

  const boot = async () => {
    const [{ setupKineticDetails }, { setupMagneticTargets }, { setupHeroPointer }] = await Promise.all([
      import('./details'),
      import('./magnetic'),
      import('./hero-pointer'),
    ]);
    if (cancelled) return;
    cleanups = [
      setupKineticDetails(reduced),
      setupMagneticTargets(reduced, finePointer),
      setupHeroPointer(reduced, finePointer),
    ];
  };

  if (idleWindow.requestIdleCallback) {
    idleHandle = idleWindow.requestIdleCallback(() => { void boot(); });
  } else {
    timeoutHandle = window.setTimeout(() => { void boot(); }, 480);
  }

  return () => {
    cancelled = true;
    if (idleHandle && idleWindow.cancelIdleCallback) idleWindow.cancelIdleCallback(idleHandle);
    if (timeoutHandle) window.clearTimeout(timeoutHandle);
    cleanups.reverse().forEach((cleanup) => cleanup());
    cleanups = [];
  };
}
